module.exports = "好乐医同时服务医生与患者。马兰头为移动医疗APP”易转诊“嵌入马兰头融合视讯云引擎，提供视频咨询，优化医生和患者使用体验。"